require('./prerequis.scss');

export default class PrerequisComponent {
  constructor() {
    this.controller = PrerequisController;
    this.template = require('./prerequis.html');
    this.bindings = {
      prefix: '@',
      initialData: '<',
      onPrerequisChange: '&',
      typePersonne: '<'
    };
  }
}

class PrerequisController {
  $onInit() {
    this.data = this.initialData || {};
    this.prefix = this.prefix ? this.prefix : '';
  }

  onChange() {
    this.onPrerequisChange({prerequis: this.data});
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/components/prerequis/prerequis.component.js